import React__default from 'react';
import { H as HelpTip } from '../HelpTip/HelpTip-t30Z2UPH.js';
import { i as isFunction } from '../LocalModules/storm-ui-utils/dist/esm/isFunction-DjxTmSal-DjxTmSal.js';

const RenderLabelEndWithHelptip = ({
  renderLabelEnd,
  help
}) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isFunction(renderLabelEnd) && renderLabelEnd(), /*#__PURE__*/React__default.createElement(HelpTip, {
  position: "right"
}, help));

export { RenderLabelEndWithHelptip as R };
//# sourceMappingURL=RenderLabelEndWithHelptip-CFJvYJ7q.js.map
